import { List, Select } from '@mantine/core';
import React, { useState } from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { PodRecordSet, RecordSetManager } from '../../../concepts/objects/RecordSetManager';
import { DebugInspect } from '../../../ui/DebugInspect';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';

const RecordSetInfoView = React.memo(({ recordSet }: { recordSet: PodRecordSet<any> }) => {

    const list = useObserver(recordSet);

    return <Flexer>
        <List>
            {list.map(r => (
                <List.Item key={r.id}>
                    <DebugInspect value={r.getState()} />
                </List.Item>
            ))}
        </List>
    </Flexer>;
});

export const DeveloperRecordsInfo = () => {

    const rm = useResolve(RecordSetManager);
    const records = rm.toArray();
    const [selected, setSelected] = useState(records[0]?.name ?? '');
    const selectedRecord = React.useMemo(
        () => records.find(r => r.name === selected) ?? records[0],
        [records, selected]
    );

    return <Flexer flex="column" gap={1}>
        <Select
            label="Select Record Set"
            placeholder="Choose a record set"
            value={selected}
            onChange={setSelected}
            data={records.map(x => x.name)}
        />
        {selectedRecord && (
            <RecordSetInfoView recordSet={selectedRecord} />
        )}
    </Flexer>;

};
